// DashboardHeader.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { fetchMe } from '../../api/api';

const DashboardHeader = () => {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const loadUserInfo = async () => {
      try {
        const userData = await fetchMe();
        setUserEmail(userData.email || '');
      } catch (error) {
        console.error('Error loading user info:', error);
      }
    };

    loadUserInfo();
  }, []);

  const handleLogout = () => {
    // Perform logout actions (e.g., clear session, redirect to login page)
    navigate('/dashboard/logout');
  };

  return (
    <Navbar bg="light" expand="lg" className="container-fluid">
      <Container>

        <Navbar.Brand as={Link} to="/dashboard/">
          <img
            src="/logo192.png"
            alt="Sôra Logo"
            width="30"
            height="30"
            className="d-inline-block align-top me-2"
          />
          Sôra
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <NavDropdown title="Atividades" id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/dashboard/activity/add">Adicionar</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/dashboard/activity/saved">Todas Atividades</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/dashboard/activity/favorites">Atividades Favoritas</NavDropdown.Item>
              {/* <NavDropdown.Item disabled>Disabled example</NavDropdown.Item> */}
            </NavDropdown>
            <NavDropdown title="Semanário" id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/dashboard/weekly/add">Adicionar</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/dashboard/weekly/list">Listar</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Categorias" id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/dashboard/category/add">Adicionar</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/dashboard/category/list">Listar</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Matérias" id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/dashboard/subject/add">Adicionar</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/dashboard/subject/list">Listar</NavDropdown.Item>
            </NavDropdown>
            <Link to="/dashboard/survey" className="btn btn-outline-primary ml-lg-3 mt-2 mt-lg-0 align-self-lg-center">
              Enviar opinião
            </Link>
          </Nav>
          <Nav>
            <NavDropdown
              title={<FontAwesomeIcon icon={faUser} />}
              id="basic-nav-dropdown"
              className="ml-auto"
              align="end"
            >
              {userEmail && (
                <NavDropdown.Item disabled className="text-muted">
                  E-mail: {userEmail}
                </NavDropdown.Item>
              )}
              {userEmail && <NavDropdown.Divider />}
              <NavDropdown.Item as={Link} to="/dashboard/profile">Perfil</NavDropdown.Item>
              {/* <NavDropdown.Item as={Link} to="/dashboard/password/change">Alterar Senha</NavDropdown.Item> */}
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default DashboardHeader;
